import React, {useEffect, useState} from 'react'
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import classNames from "classnames";
import _ from "lodash";
import {directMessageSetReceiverTagOwner} from "../../exhibition_actions";
import RenderedHtmlContent from "../rendered_html_content";
import {useUnreadMessages} from "./utils";

const ChatParticipant = ({user, translations, setShowParticipants}) => {
  const dispatch = useDispatch()
  const useOnlineStatus = useSelector((state) => state.directMessaging?.useOnlineStatus)
  const unreadMessages = useUnreadMessages(user.id)

  let onlineState = null

  if (useOnlineStatus) {
    if ("is_online" in user) {
      if (user.is_online) {
        onlineState = "online"
      } else {
        onlineState = "offline"
      }
    }
  }

  const badgeStyle = onlineState === "online" ? "badge-success" : "badge-secondary"
  const showBadge = unreadMessages.length > 0 || onlineState === "online"

  let chatListItem = <>
    <strong>
      {showBadge && <div className={`badge badge-pill ${badgeStyle}`}>
        {unreadMessages.length > 0 ? unreadMessages.length : "\u00A0"}
      </div>}
      {" " + user.name}
    </strong>
    {user.position && <>
      <br/>
      {user.position}
    </>}
  </>
  if (translations?.userList?.chatListItem) {
    chatListItem = <RenderedHtmlContent
      placeholders={{
        tagOwner: user,
        onlineState: onlineState
      }}
      html={translations?.userList?.chatListItem}
    />
  }

  return <div key={user.id} className="row">
    <div className="col-12" onClick={() => {
      if (user.isDirectMessagingEnabled) {
        dispatch(directMessageSetReceiverTagOwner(user))
        setShowParticipants(false)
      }
    }}>
      <div className={classNames("search-result", {"disabled": !user.isDirectMessagingEnabled})}>
        {chatListItem}
      </div>
    </div>
  </div>;
}

// const useParticipantList = () => {
//   const useOnlineStatus = useSelector((state) => state.directMessaging?.useOnlineStatus)
//   const directMessageCompleteParticipantListUrl = useSelector((state) => state.directMessaging.directMessageCompleteParticipantListUrl)
//   const [isLoadingParticipantList, setIsLoadingParticipantList] = useState(useOnlineStatus)
//   const [participantList, setParticipantList] = useState([])
//
//   useEffect(() => {
//     if (useOnlineStatus && chats.length > 0) {
//       setIsLoadingParticipantList(true)
//
//       axios.post(directMessageCompleteParticipantListUrl, {tag_owner_ids: chats.map(chat => chat.tagOwner.id)}).then(data => {
//           if (data.data.status === "OK") {
//             setParticipantList(data.data.tagOwnerResults)
//           } else {
//             alert(data.data.message || "A error occurred while loading.")
//           }
//           setIsLoadingParticipantList(false)
//         },
//         error => {
//           alert(error)
//           console.error(error)
//           setParticipantList([])
//         }).then(function () {
//         setIsLoadingParticipantList(false)
//       })
//     }
//   }, [])
// }


const allLetter = "ALL"

const shouldShowTagOwner = (tagOwner, filter, minFilterLength, letterSearchEnabled, selectedLetter) => {
  let searchTextParts = filter.split(" ")

  const shouldBeVisibleByLetterSearch = !letterSearchEnabled || selectedLetter === allLetter || (tagOwner.lastname && tagOwner.lastname[0].toUpperCase() === selectedLetter)
  let shouldBeVisibleByFilter = true
  if (filter && filter.length >= minFilterLength) {
    let userSearchParts = tagOwner.name.split(" ")
    if (tagOwner.company) {
      userSearchParts = userSearchParts.concat(tagOwner.company.split(" "))
    }
    if (tagOwner.position) {
      userSearchParts.push(tagOwner.position)
    }

    shouldBeVisibleByFilter = searchTextParts.every(stp => userSearchParts.some(lip => lip.toLowerCase().includes(stp.toLowerCase())))
  }

  return shouldBeVisibleByFilter && shouldBeVisibleByLetterSearch
}

export default function CompleteUserList({setShowParticipants, translations, disabledBackButton, reloadUsersOnFilterChange}) {
  const [isLoading, setIsLoading] = useState(true);
  const [filter, setFilter] = useState("");
  const [userList, setUserList] = useState([]);
  const directMessageCompleteParticipantListUrl = useSelector((state) => state.directMessaging.directMessageCompleteParticipantListUrl)
  const tagOwner = useSelector((state) => state.tagOwner)
  const letterSearchEnabled = useSelector((state) => state.directMessaging?.enableRegistry)
  const minFilterLength = useSelector((state) => state.directMessaging?.minFilterLength) || 1
  const readMessageIds = useSelector((state) => state.directMessaging.readMessageIds)
  const messages = useSelector((state) => state.directMessaging.messages)

  const letters = _.uniq(_.compact(userList.map(user => user.lastname && user.lastname[0].toUpperCase()))).sort()
  const availableLetters = [allLetter].concat(letters)
  const [selectedLetter, setSelectedLetter] = useState(allLetter)

  console.log({userList})

  const loadUsers = () => {
    setIsLoading(true)

    const data = {
      filter
    }
    axios.post(directMessageCompleteParticipantListUrl, data).then(data => {
        if (data.data.status === "OK") {
          console.log({dd: data.data})
          setUserList(data.data.tagOwnerResults?.filter(user => user.id != tagOwner.id))
        } else {
          alert(data.data.message || "A error occurred while loading.")
        }
        setIsLoading(false)
      },
      error => {
        alert(error)
        console.error(error)
        setUserList([])
      }).then(function () {
      setIsLoading(false)
    })
  }

  useEffect(() => {
    loadUsers()
  }, [])

  useEffect(() => {
    const interval = setInterval(loadUsers, 60 * 1000)
    return () => {
      clearInterval(interval)
    }
  }, [])

  useEffect(() => {
    if (reloadUsersOnFilterChange) {
      const timeout = setTimeout(loadUsers, 1500)
      return () => {
        clearTimeout(timeout)
      }
    }
  }, [reloadUsersOnFilterChange, filter])

  const filteredUsers = userList.filter(user => shouldShowTagOwner(user, filter, minFilterLength, letterSearchEnabled, selectedLetter))

  const hasUnreadMessageSort = (user) => {
    const unreadMessages = messages
      .filter(message => message.receiver_tag_owner_id === tagOwner.id) // only own messages
      .filter(message => message.sender_tag_owner_id === user.id) // filter for this sender
      .filter(message => !message.read_at) // is not read
      .filter(message => readMessageIds.indexOf(message.id) === -1) // is not read
    return unreadMessages.length > 0
  }

  const hasAlreadyChatted = (user) => {
    const unreadMessages = messages
      .filter(message => message.receiver_tag_owner_id === user.id || message.sender_tag_owner_id === user.id) // only own messages
    return unreadMessages.length > 0
  }

  const sortedUsers = _.orderBy(filteredUsers, ["isDirectMessagingEnabled", hasUnreadMessageSort, hasAlreadyChatted, "is_online", "lastname", "firstname", "id"], ["desc", "desc", "desc", "desc", "asc", "asc", "asc"])

  if (isLoading) {
    return <div className={"text-center"}>
      <div className="spinner-border text-dark" role="status">
        <span className="sr-only">{translations.loadingText || "Loading..."}</span>
      </div>
    </div>
  }

  return <>
    <style>
      {`
      .modal-body {
        max-height: 70vh;
      }
      
      /* Hide scrollbar for Chrome, Safari and Opera */
      .hidden-scrollbar::-webkit-scrollbar {
        display: none;
      }

      /* Hide scrollbar for IE, Edge and Firefox */
      .hidden-scrollbar {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
      }
      `}
    </style>
    {!disabledBackButton && <div className="row">
      <div className="col-12">
        <div className="back-button" onClick={() => {
          setShowParticipants(false)
        }}>
          {translations.backText || "Back"}
        </div>
      </div>
    </div>}


    {!reloadUsersOnFilterChange && sortedUsers.length === 0 && <div className="row">
      <div className="col-12 text-center" style={{paddingTop: "1rem"}}>
        {translations.userNotFoundText || "No user found"}
      </div>
    </div>}

    <div className="input-group chat-window-input-form-group text-center">
      <input
        className="form-control"
        autoFocus
        type="text"
        onKeyDown={(e) => setFilter(e.target.value)}
        placeholder={translations.searchForMembersPlaceholder || "Search for other members"}
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
      />
    </div>

    <div className="row">
      <div className="col-12 limited-height-container" style={{display: "flex"}}>
        {letterSearchEnabled &&
        <div className={"limited-height-container hidden-scrollbar"} style={{display: "flex", flexDirection: "column"}}>
          {availableLetters.map((letter) => {
            console.log({translations})
            let buttonContent = letter
            if (translations?.userList?.allButtonHtml && letter === allLetter) {
              buttonContent = <RenderedHtmlContent html={translations?.userList?.allButtonHtml}/>
            }

            return <button
              key={letter}
              type={"button"}
              className={classNames("registry-button", {"is-selected": selectedLetter == letter})}
              onClick={() => setSelectedLetter(letter)}
              style={{
                marginRight: "15px",
                backgroundColor: selectedLetter == letter ? "rgb(84 84 84)" : "#efefef",
                color: selectedLetter == letter ? "black" : "#4a4a4a",
                fontWeight: selectedLetter == letter ? "bold" : "normal",
                border: "1px solid #e4e4e4",
                borderRadius: "0.5rem",
                margin: "0.1rem 0",
              }}
            >
              {buttonContent}
            </button>
          })}
        </div>}
        <div className={"container-fluid limited-height-container"} style={{flexGrow: "1"}}>
          {sortedUsers.map((user) => <ChatParticipant user={user} setShowParticipants={setShowParticipants} translations={translations} />)}
        </div>
      </div>
    </div>
  </>;
}